import React from 'react';
import useEventBus from '../../eventBus/useEventBus';
import { useCookies } from 'react-cookie';
import { LocationCookie } from '../utils/constants';
import { updateZipcodeCookies } from '../utils/cookieUpdater';
export const ZipcodeContext = React.createContext({});
export default ({
  initialZipInfo,
  children
}) => {
  const [, setCookie] = useCookies([LocationCookie]);
  useEventBus('zipcode.updated', newZipInfo => {
    updateZipcodeCookies(newZipInfo, setCookie);
  });
  return React.createElement(ZipcodeContext.Provider, {
    value: initialZipInfo
  }, children);
};